import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { adminDashboardDetailsApi } from "../../../utils/ApiEndpointFunctions";
import Spinwheel from "../../common/Spinwheel";
import { useAdminContext } from "../../../context/adminContext";
import { useNavigate } from "react-router-dom";
import MetricCard from "./components/MetricCard";
import CarRentalsEarningChart from "./components/CarRentalsEarningChart";

export default function CarRentalsDashboard() {
  const [loader, setLoader] = useState(false)
  const [details, setDetails] = useState({})
  const { setAdminDetail, adminDetail } = useAdminContext();
  const navigate = useNavigate()

  const getDashboardDetails = async () => {
    try {
      setLoader(true);
      const res = await adminDashboardDetailsApi();
      setDetails(res?.data?.data);
      setLoader(false);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      setLoader(false);
    }
  }

  // useEffect(() => {
  //   if (adminDetail?.role === "superAdmin") {
  //     getDashboardDetails();
  //   } else {
  //     navigate("/partners?type=all")
  //   }

  // }, [adminDetail?.role])

  const metrics = [
    {
      label: "Total Car Rentals Company",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Total Cars",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Total Booking",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Total Cancel Booking",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Application Car Rentals",
      value: 0,
      background: "#E3F5FF",
    },

    {
      label: "Reject Car Rentals",
      value: 0,

      background: "#E5ECF6",
    },
  ]


  return (
    <>
      <div className="main-content">

        <div className="container-fluid ">
          {
            loader ? <Spinwheel /> :
              <>
                <div className="mt-2 g-4 card rounded-2">
                  <div className="metric_row">

                    {metrics.map((metric, index) => (
                      <MetricCard
                        key={index}
                        label={metric.label}
                        value={metric.value}
                        background={metric.background}
                      />
                    ))}

                  </div>

                  <div className="row">
                    <CarRentalsEarningChart />
                  </div>
                </div>
              </>
          }

        </div>
      </div>
    </>
  );
}
